import React from 'react';
import ProfilePicture from '../profile-picture';

export type ContactItem = {
  href?: string;
  icon: string;
  label: string;
  newTab?: boolean;
};

interface ProfileHeaderCardProps {
  className?: string;
  imageUrl?: string;
  name: string;
  nameHeadingClassName?: string;
  nameActions?: React.ReactNode;
  subtitle?: string;
  contactItems?: ContactItem[];
  contactInfo?: React.ReactNode;
  rightActions?: React.ReactNode;
}

export const ProfileHeaderCard: React.FC<ProfileHeaderCardProps> = ({
  className = '',
  imageUrl,
  name,
  nameHeadingClassName = 'text-xl font-semibold text-gray-900',
  nameActions,
  subtitle,
  contactItems,
  contactInfo,
  rightActions,
}) => {
  return (
    <div className={`w-full flex flex-col md:flex-row justify-between items-start md:items-center gap-4 ${className}`}>
      <div className="flex items-center gap-4">
        <ProfilePicture name={name} url={imageUrl} />
        <div className="flex flex-col gap-2">
          <div>
            <div className="flex flex-wrap items-center gap-2">
              <h2 className={nameHeadingClassName}>{name}</h2>
              {nameActions && <div>{nameActions}</div>}
            </div>
            {subtitle && <p className="text-base text-gray-600">{subtitle}</p>}
          </div>
          {contactItems && contactItems.length > 0 && (
            <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600">
              {contactItems.map(item =>
                item.href ? (
                  <a
                    className="flex items-center gap-2 rounded-full border border-gray-200 px-3 py-1.5 text-gray-700 transition hover:border-gray-300"
                    href={item.href}
                    key={`${item.icon}-${item.label}`}
                    rel={item.newTab ? 'noreferrer' : undefined}
                    target={item.newTab ? '_blank' : undefined}>
                    <img alt="" src={item.icon} className="h-4 w-4" />
                    <span className="font-medium">{item.label}</span>
                  </a>
                ) : (
                  <div
                    className="flex items-center gap-2 rounded-full border border-gray-200 px-3 py-1.5 text-gray-700 transition hover:border-gray-300"
                    key={`${item.icon}-${item.label}`}>
                    <img alt="" className="h-4 w-4 opacity-70" src={item.icon} />
                    <span className="font-medium">{item.label}</span>
                  </div>
                ),
              )}
            </div>
          )}
          {contactInfo && <div>{contactInfo}</div>}
        </div>
      </div>

      {rightActions && <div className="flex flex-wrap gap-3 sm:flex-shrink-0">{rightActions}</div>}
    </div>
  );
};
